module.exports = __webpack_public_path__ + "img/map.990da8fb.jpg";